export enum RtkTags {
  Vehicle = 'Vehicle',
  Inspection = 'Inspection',
  Contact = 'Contact',
  Station = 'Station',
  Attachment = 'Attachment',
  InspectionVehicle = 'InspectionVehicle',
}
